class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        const item = entries[0];

        if (item.intersectionRatio > 0) {
          const nextPage = Number(item.target.dataset.currentPage) + 1;
          if (nextPage > item.target.dataset.totalPages) return;

          this.renderNextPage(nextPage);
          item.target.dataset.currentPage = nextPage;
        }
      },
      { rootMargin: '0px 0px 500px 0px' }
    );

    this.observer.observe(this);
  }

  renderNextPage(page) {
    const section = document.getElementById('main-collection-product-grid').dataset.id;
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.append('page', page);

    const url = `${window.location.pathname}?section_id=${section}&${searchParams.toString()}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const destination = document.getElementById('main-collection-product-grid');
        const source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelectorAll('#main-collection-product-grid li');

        let fragment = new DocumentFragment();
        source.forEach((item) => fragment.appendChild(item));

        destination.append(fragment);

        // fix bug in Safari where srcset doesn't render correctly for images loaded asynchronously
        this.reloadSrcsetImgs(document);
      });
  }

  reloadSrcsetImgs(item) {
    var imgs = item.querySelectorAll('img[srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.outerHTML = img.outerHTML;
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
